// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__BAUQ7","on":"Toggle_on__RwhAn","disabled":"Toggle_disabled__7kLiJ","thumb":"Toggle_thumb__kOpHg","isMobile":"Toggle_isMobile__SCb1P"};